export enum ROUTER_ADMIN_PASSWORD_UPDATE_STATUS {
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
  UNKNOWN = 'unknown',
}
